export const ASSISTANT_VARIABLE_CATALOG_MAX_ITEMS = 300;
